import {Injectable, OnDestroy} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  unsubscribe: Subject<void> = new Subject<void>();
  OF_LABEL = 'of ';
  PAGE_LABEL = 'Page';
  UNIQUE_PAGE_LABEL = 'Page 1 of 1';

  constructor(private translate: TranslateService) {
    super();
    this.getAndInitTranslations();

    this.defaultLabels();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getAndInitTranslations() {
    this.translate
      .get([
        'paginator.firstPage',
        'paginator.itemsPerPage',
        'paginator.lastPage',
        'paginator.nextPage',
        'paginator.previousPage',
        'paginator.uniquePage',
        'paginator.page',
        'paginator.of',
      ])
      .subscribe((translation) => {
        this.firstPageLabel = translation['paginator.firstPage'];
        this.itemsPerPageLabel = translation['paginator.itemsPerPage'];
        this.nextPageLabel = translation['paginator.nextPage'];
        this.previousPageLabel = translation['paginator.previousPage'];
        this.UNIQUE_PAGE_LABEL = translation['paginator.uniquePage'];
        this.OF_LABEL = translation['paginator.of'];
        this.PAGE_LABEL = translation['paginator.page'];
        this.lastPageLabel = translation['paginator.lastPage'];
        this.changes.next();
      });
    this.translate.onLangChange.subscribe(() => {
      this.getAndInitTranslations();
    });
  }

  defaultLabels() {
    this.firstPageLabel = 'Primeira página';
    this.itemsPerPageLabel = 'Itens por página:';
    this.nextPageLabel = 'Próxima página';
    this.previousPageLabel = 'Página anterior';
    this.UNIQUE_PAGE_LABEL = 'Página 1 de 1';
    this.OF_LABEL = 'de ';
    this.PAGE_LABEL = 'Página';
    this.lastPageLabel = 'Última página';
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `${this.UNIQUE_PAGE_LABEL}`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `${this.PAGE_LABEL} ${page + 1} ${this.OF_LABEL} ${amountPages}`;
  };
}
